let _audio = null
let _enabled = false

export function initAudio(url, enabled = true) {
  cleanup()
  if (!url || !enabled) return
  _audio = new Audio(url)
  _audio.loop = true
  _enabled = enabled
}

export function play() {
  if (_audio && _enabled) _audio.play().catch(() => {})
}

export function pause() {
  _audio?.pause()
}

export function stop() {
  cleanup()
}

export function toggle() {
  _enabled = !_enabled
  _enabled ? play() : pause()
  return _enabled
}

export function isEnabled() {
  return _enabled
}

export function hasAudio() {
  return _audio !== null
}

export function cleanup() {
  if (_audio) {
    _audio.pause()
    _audio = null
  }
  _enabled = false
}
